module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Deposit")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": !_vm.$can('edit', 'case-deposit'),
      "label": "Amount",
      "prefix": "$"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "color": "primary",
            "disabled": !_vm.$can('edit', 'case-deposit'),
            "flat": "",
            "loading": _vm.loading
          },
          on: {
            "click": _vm.changeDeposit
          }
        }, [_vm._v("Save deposit and send receipt")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.deposit),
      callback: function($$v) {
        _vm.deposit = $$v
      },
      expression: "deposit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Left to Pay")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    staticClass: "disabled-active",
    attrs: {
      "disabled": true,
      "value": _vm.leftToPay,
      "label": "Amount",
      "prefix": "$"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-201be0e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseDeposit.vue
// module id = 939
// module chunks = 1